import { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import FirmaDocumentosDetailContainer from '../../components/firmas-documentos-detail-container/FirmaDocumentosDetailContainer';

class FirmasDocumentosDetail extends Component {
  render() {
    return (
      <div>
        <FirmaDocumentosDetailContainer id={this.props.match.params.id} />
      </div>
    );
  }
}

FirmasDocumentosDetail.propTypes = {
  match: PropTypes.object,
};

export default withRouter(FirmasDocumentosDetail);
